module.exports = __webpack_public_path__ + "img/initNoCouse_icon.3f34c2ed.png";